import { Component, OnInit, Input, AfterViewInit, OnChanges, Directive, ElementRef } from '@angular/core';
import {Agent, Role, Status, Permission} from '../../../../../models';

@Component({
  selector: 'app-agent-statistics',
  templateUrl: './agent-statistics.component.html',
  styleUrls: ['./agent-statistics.component.css']
})

export class AgentStatisticsComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() userAgentStatistics: any;
  math = Math;

  percent: string;
  color: string;

  

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    // if(this.userAgentStatistics != null){
    //   
    // }
  }

  ngOnChanges(){
    if(this.userAgentStatistics.sales != undefined){
      this.percent = this.userAgentStatistics.sales[0].ksp + '%';
      if(this.userAgentStatistics.sales[0].ksp >= 90){
        this.color = '#ADB837';
      }
      else if(this.userAgentStatistics.sales[0].ksp >= 80 && this.userAgentStatistics.sales[0].ksp < 90) {
        this.color = '#FFA500'; //FFA500
      }
      else if(this.userAgentStatistics.sales[0].ksp < 80 ) {
        this.color = 'red'; 
      }

      //this.userAgentStatistics.sales[0].ksp = 50;
      //this.el.nativeElement.style.width = this.userAgentStatistics.sales[0].ksp;
    }
  }
  
}
